module.exports = __webpack_public_path__ + "static/media/BL.add959df.svg";